export const SIDE_PANEL_WIDTH = 400;
export const FORCE_PREMIUM = false;
